import { jsx as _jsx } from "react/jsx-runtime";
var PlayArrow = function PlayArrow(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M22 12L5.5 21.5263L5.5 2.47372L22 12Z",
      fill: !ignoreColor ? color : undefined
    })
  });
};
export default PlayArrow;